import Constants from "expo-constants";

export const pow2abs = (a: number, b: number): number => {
  return Math.pow(Math.abs(a - b), 2);
};
export const getDistance = (touches: any): number => {
  const [a, b] = touches;

  if (a == null || b == null) {
    return 0;
  }
  return Math.sqrt(pow2abs(a.pageX, b.pageX) + pow2abs(a.pageY, b.pageY));
};

export const getScale = (
  currentDistance: number,
  initialDistance: number
): number => {
  return (currentDistance / initialDistance) * 1.2;
};

export const hasAnyExtension = (url: string | null | undefined) => {
  if (!url || typeof url !== "string" || url.trim() === "") return true;
  return /\.[0-9a-z]+(\?|$)/i.test(url);
};

export const isGoogleURL = (url: string | null | undefined) => {
  if (!url || typeof url !== "string" || url.trim() === "") return true;
  return url.includes("drive.") || url.includes("google.");
};

export const isJPGUrl = (url?: string) => {
  if (!url) return false;
  try {
    const pathname = new URL(url).pathname.toLowerCase();
    return (
      pathname.endsWith(".jpg") ||
      pathname.endsWith(".jpeg") ||
      pathname.endsWith(".png")
    );
  } catch {
    return (
      url.toLowerCase().split("?")[0].endsWith(".jpg") ||
      url.toLowerCase().split("?")[0].endsWith(".jpeg") ||
      url.toLowerCase().split("?")[0].endsWith(".png")
    );
  }
};

export const isPdfUrl = (url?: string) => {
  const lowerCaseUrl = url?.toLowerCase();
  return !lowerCaseUrl?.includes(".pdf");
};

export const getAppVersion = () => {
  const appVersion = process.env.APP_VERSION
    ? process.env.APP_VERSION
    : Constants?.expoConfig?.extra?.appVersion;
  const buildVersion = process.env.EXPO_PUBLIC_BUILD_DATE
    ? process.env.EXPO_PUBLIC_BUILD_DATE
    : Constants?.expoConfig?.extra?.buildVersion;
  return appVersion + "." + buildVersion;
};
